import { render, staticRenderFns } from "./kycDialog.vue?vue&type=template&id=6a67efc3&scoped=true&"
import script from "./kycDialog.vue?vue&type=script&lang=js&"
export * from "./kycDialog.vue?vue&type=script&lang=js&"
import style0 from "./kycDialog.vue?vue&type=style&index=0&id=6a67efc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67efc3",
  null
  
)

export default component.exports